const apiUrl = process.env.REACT_APP_API_URL;
export const GetAlumnesValidacioByProject = async (id_projecte : string, id_alumne : string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/projectes/${id_projecte}/alumnes/${id_alumne}/validacio`);
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
